import {type Mock, vi} from 'vitest'
/** @internal */
export const mockBrowserEnvironment: Mock = vi.fn(() => vi.fn())
